import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDatepickerInputEvent } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { FormControl } from '@angular/forms';
import { HOURS, MINUTES15 } from '../../common/constants';

export interface DialogData {
  any: any
}

@Component({
  selector: 'app-exchange-edit-dialog',
  templateUrl: './exchange-edit-dialog.component.html',
  styleUrls: ['./exchange-edit-dialog.component.less']
})
export class ExchangeEditDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 画面上半分に表示するデータ
  exchangeDialogData: any;

  // 振替指定日の日付
  exchangeDay: string = moment(this.data['day']).format('YYYY-MM-DD');

  // 画面表示用日付
  dayForDisp: string = moment(this.data['day']).format('YYYY/MM/DD');

  // 変更先のカレンダー：開いたときに出す月（振替指定日の月）
  originDate: Date = moment(this.data['day']).toDate();

  // 変更先のカレンダー：振替指定日（開いた日）に付けるクラス（紫の輪。今日の丸は styles.less で消している）
  originClass = (d: Date) => moment(d).format('YYYY-MM-DD') == this.exchangeDay ? 'origin-day' : '';

  // 物件名
  siteName: '';

  // 時間ドロップダウン
  hours: number[] = HOURS;

  // 分ドロップダウン
  minutes: string[] = MINUTES15;

  // 「変更を保存」ボタン　活性:true、非活性:false
  saveDisabled:boolean = false;

  // ローディング
  loadingCompleteData:boolean = false;

  // 契約の終了日（YYYY-MM-DD。契約詳細情報の一番遅い終了日。終わりが決まっていなければ null）。終了日の翌日以降の変更先は確認してから登録
  contractEndDate: string = null;
  // 契約の開始日（YYYY-MM-DD。契約詳細情報の一番早い開始日）。開始日より前の変更先も確認してから登録（契約の行の間の空きは見ない。ユーザー決定）
  contractStartDate: string = null;

  // 振替先データ
  exchange = [{
    id: null,
    sequenceNumber: this.data['sequenceNumber'],
    staffDailyCleaning: this.data['staffDailyCleaning'],
    cdSite: this.data['cdSite'],
    cdContract: this.data['cdContract'],
    nameSite: this.data['nameSite'],
    // 振替元
    day: '',
    // 変更前のデータ
    exchangeDayBefore: null,
    hourBefore: null,
    minuteBefore: null,
    note: null,
    // 変更後
    after: [{
      // 振替指定日
      exchangeDay: '',
      hour: '',
      minute: '00'
    }]
  }];

  constructor(private router: Router, private http: HttpClient, @Inject(MAT_DIALOG_DATA) private data: DialogData, private dialogRef: MatDialogRef<ExchangeEditDialogComponent>,
    private datePipe: DatePipe, private ngZone: NgZone) { }

  ngOnInit() {
    this.getData();
    this.getContractPeriod();
  }

  /**
   * 契約の期間を取得（契約詳細情報の全部の行をまとめた開始日・終了日）
   * 代勤専門（000000000）は契約が無いので取らない。取れなかったときは止めない（契約の終了日のチェックだけできない）
   * API: contractDetail/period
   */
  getContractPeriod() {
    this.contractEndDate = null;
    this.contractStartDate = null;
    if (!this.data['cdSite'] || this.data['cdSite'] == '000000000') {
      return;
    }
    this.http.get(
      API_BASE_URL + '/api/v1/contractDetail/period?cdSite=' + encodeURIComponent(this.data['cdSite'])
        + '&cdContract=' + encodeURIComponent(this.data['cdContract'] || ''),
      {headers: this.headers}
    ).subscribe(res => {
      this.contractEndDate = (res && res['endDate']) ? String(res['endDate']).substring(0, 10) : null;
      this.contractStartDate = (res && res['startDate']) ? String(res['startDate']).substring(0, 10) : null;
    }, error => {
      if (error && (error.status == 401 || error.status == 403)) {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      }
    });
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }


  /**
   * 現場に関係する清掃員情報を取得
   */
  getData() {
    console.log(this.data)
    this.http.get(API_BASE_URL + '/api/v1/sites/operationDialog?'
      + 'cdSite=' + this.data['cdSite']
      + '&cdContract=' + this.data['cdContract']
      + '&cdStaff=' + this.data['staffDailyCleaning']
      + '&day=' + moment().format('YYYY-MM-DD') // 日付は今回不要なので何でもOK、本日日付を渡す
      + '&sequenceNumber=' + this.data['sequenceNumber']
      + '&spot=' + false,
      {headers: this.headers})
      .subscribe((res) => {
        this.siteName = this.data['nameSite'];
        if (res == null || (res as []).length == 0) {
          this.exchangeDialogData = null
        } else {
          this.exchangeDialogData = res;
        }

        // 既存の振替データ取得
        this.http.get(API_BASE_URL + '/api/v1/exchange/getEdit?sequenceNumber=' + this.data['sequenceNumber']
        + '&staffDailyCleaning=' + this.data['staffDailyCleaning']
        + '&cdSite=' + this.data['cdSite']
        + '&exchangeDay=' + this.exchangeDay,
        {headers: this.headers})
        .subscribe((res) => {
          if (res != null && (res as []).length > 0) {
            this.exchange = res as [];
            // 既存のデータのプロパティ名を変更
            this.exchange.forEach((e) => {
              e.exchangeDayBefore = e['exchangeDay']
              e.hourBefore = e['hour']
              e.minuteBefore = e['minute']
              e.after = [{
                exchangeDay: '',
                hour: e['hour'],
                minute: e['minute']
              }]
            })
            // console.log(this.exchange)
          }
          this.loadingCompleteData = true;
        },
        error => {
          alert("認証に失敗しました");
          this.router.navigate(['/']);
          this.loadingCompleteData = true;
        }
      );

      },
      error => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        this.loadingCompleteData = true;
      }
    );
  }

  /**
   * 振替先の日を選択
   * @param event 選択日
   * @param i インデックス
   */
  changeDate(event: MatDatepickerInputEvent<Date>, i: number, j:number) {
    let d = new FormControl(event.value);
    this.exchange[i].after[j].exchangeDay = moment(d.value).format('YYYY-MM-DD');
  }

  /**
   * 保存ボタンイベント
   */
  save() {
    const save = this.validateAndSetData()
    if (!save || !save.length) {
      return
    }
    this.saveDisabled = true;

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.http.post(
      API_BASE_URL + '/api/v1/exchange/saveEdit?staffName=' + this.data['nameStaff']
      + '&siteName=' + this.siteName
      + '&show=' + this.data['isShow']
      , save
      , httpOptions
    ).subscribe(res => {
      this.dialogRef.close(true);
    },error => {
      alert('認証に失敗しました');
      this.router.navigate(['/']);
      this.dialogRef.close();
    });
  }

  /**
   * 閉じるボタンイベント
   */
  close() {
    this.dialogRef.close();
  }

  /**
   * 削除ボタン
   * @param ex 振替データ
   * @param j インデックス
   */
  delete(ex, j) {
    ex.after.splice(j, 1);
  }

  /**
   * 追加ボタン
   */
  add(ex) {
    console.log(ex)
    ex.after.push({
      exchangeDay: '',
      hour: '',
      minute: '00'
    })
  }

  /**
   * バリデートとデータを成形する
   * @returns
   */
  validateAndSetData() {
    let res = []
    let count = 0
    let noSaveIdx = []
    for (let i = 0; i < this.exchange.length; i++) {
      const ex = this.exchange[i];
      for (let j = 0; j < ex.after.length; j++) {
        const e = ex.after[j];
        count++

        if (e.exchangeDay && e.exchangeDay != 'Invalid date' && e.hour && e.minute) {
          if (!(e.hour == '0' && e.minute == '00')) {
            res.push({
              id: ex.id,
              sequenceNumber: ex.sequenceNumber,
              staffDailyCleaning: ex.staffDailyCleaning,
              cdSite: ex.cdSite,
              cdContract: ex.cdContract,
              nameSite: ex.nameSite,
              // 振替元日
              day: ex.day,
              // 振替指定日
              exchangeDay: e.exchangeDay,
              hour: e.hour,
              minute: e.minute
            })
          } else {
            noSaveIdx.push(count)
          }
        } else {
          noSaveIdx.push(count)
        }
      }
    }

    // 保存するデータがない場合
    if (!res || !res.length) {
      alert('保存するデータがありません。変更先の記入を完成させてください。')
      return null
    } else if (noSaveIdx && noSaveIdx.length) {
      if (!window.confirm(noSaveIdx.join('、') + '番目のデータは変更されませんがよろしいでしょうか？')) {
        return null
      }
    }
    // 契約の終了日の翌日以降の変更先があれば確認（契約が終わった物件に時間を回しても誰も清掃しない。止めはしない。ユーザー決定）
    if (this.contractEndDate) {
      const over = res
        .filter(r => String(r.exchangeDay) > this.contractEndDate)
        .map(r => moment(r.exchangeDay).format('YYYY/MM/DD'))
      if (over.length && !window.confirm('契約詳細情報で契約が終了しています。本当によろしいですか？\r\n\r\n'
        + '契約終了日：' + moment(this.contractEndDate).format('YYYY/MM/DD') + '\r\n'
        + '終了日より後の変更先：' + over.join('、'))) {
        return null
      }
    }
    // 一番早い開始日より前の変更先も同じく確認（契約の行の間の空きは見ない。ユーザー決定）
    if (this.contractStartDate) {
      const before = res
        .filter(r => String(r.exchangeDay) < this.contractStartDate)
        .map(r => moment(r.exchangeDay).format('YYYY/MM/DD'))
      if (before.length && !window.confirm('契約詳細情報で契約がまだ始まっていません。本当によろしいですか？\r\n\r\n'
        + '契約開始日：' + moment(this.contractStartDate).format('YYYY/MM/DD') + '\r\n'
        + '開始日より前の変更先：' + before.join('、'))) {
        return null
      }
    }
    return res
  }
}
